import { Pipe, PipeTransform } from '@angular/core';
import { MetricDefinition } from 'src/shared/models/pipeline-config/metric-definition.models';

@Pipe({
    name: 'categorizeMetricDefinitions',
})
export class CategorizeMetricDefinitions implements PipeTransform {

    /**
     * This pipe accepts an array of MetricDefinitions and returns a mapping of Metric Category to Metric Definitions
     * E.g. [md1, md2, md3] -> [[g1, [md2, md3]], [g2, [md1]]]
     * Used by the template markup of metric-definitions-landing
     * @param metricDef 
     * @param args 
     */
    transform(metricDef: MetricDefinition[]): CategorizedMetricDefinitions {
        if (!Array.isArray(metricDef) || metricDef.length == 0)
            return [];

        let categoriesMap = new Map<string, MetricDefinition[]>();
        for (let m of metricDef) {
            if (m && m.Group) {
                let defs = categoriesMap.get(m.Group);
                if (!defs) {
                    defs = [];
                    categoriesMap.set(m.Group, defs);
                }
                defs.push(m);
            }
        }

        let result: CategorizedMetricDefinitions = [];
        for (let [k, v] of categoriesMap) {
            v.sort((a, b) => a.Abreviation.localeCompare(b.Abreviation, undefined, { sensitivity: "base" }));
            result.push([k, v]);
        }
        result.sort((a, b) => a[0].localeCompare(b[0], undefined, { sensitivity: "base" }));

        return result;
    }

}

type CategorizedMetricDefinitions = [string, MetricDefinition[]][];
